import React from 'react';
import ClusterSelectionGrid from '../components/ClusterSelectionGrid';

const ClustersPage = () => {
    return (
        <div className="p-3 sm:p-4 md:p-6">
            <h2 className="text-lg sm:text-xl md:text-2xl font-bold text-blue-500 mb-3 sm:mb-4 md:mb-6">
                Кластеры
            </h2>

            <ClusterSelectionGrid />
        </div>
    );
};

export default ClustersPage;
